import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mprd-cyber-care-yearly-price',
  templateUrl: './cyber-care-yearly-price.component.html',
})
export class CyberCareYearlyPriceComponent implements OnInit {
  @Input() yearlyPrice: number;

  priceArray: string[];

  constructor() {}

  ngOnInit(): void {
    this.priceArray = this.yearlyPrice.toFixed(2).toString().split('.');
  }
}
